import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { BaseComponent } from '../base.component';
import { LogHandlerService } from '../../services/log-handler.service';
import { ProjectsViewmodel } from '../../models/view/projects.viewmodel';

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.scss'],
    standalone: false
})
export class ProjectsComponent extends BaseComponent<ProjectsViewmodel> implements OnInit {


  constructor(
    private commonService: CommonService,
    private exceptionHandler: LogHandlerService,
  ) {
    super(commonService, exceptionHandler)
    this.viewModel = new ProjectsViewmodel();
    this._commonService.layoutViewModel.stickyMenu = false;
  }

  async ngOnInit() {
    await this._commonService.presentLoading();
    await this._commonService.dismissLoader();
  }


  SwitchProjects(index:number){
    if(this.viewModel.currentSubProject !== index){
      this.viewModel.currentSubProject = index;
    }
  }

}

